import DashHeatMap from "../../../../components/dash-heat-map.jsx";

export default function ActionsHeatmap({ data }) {
    return (
        <article className="mt-8! flex min-h-0 flex-col p-4">
            <h3 className="mb-4! text-center">Quantidade de ações por dia</h3>
            <DashHeatMap data={data} className="flex-1" />
        </article>
    );
}
